import React, { useRef } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import {
	Container,
	ChevronIcon,
	Header,
	ListItem,
	Title,
	UnorderedList,
} from './AccordionItem.styles';
import { Paragraph } from '@welbe/web-design-system';

type ProFileExamProps = {
	id: string;
	name: string;
	coverage?: boolean;
};

type AccordionItemProps = {
	handleToggle: (id: string) => void;
	activeItems: string[];
	item: {
		id: string;
		name: string;
		profileExams: ProFileExamProps[];
		minSla?: number;
		maxSla?: number;
	};
};

export const AccordionItem = ({
	handleToggle,
	activeItems,
	item,
}: AccordionItemProps) => {
	const contentEl = useRef<HTMLDivElement>(null);
	const { name, id, profileExams, minSla, maxSla } = item;
	const hasSlaValue = minSla && maxSla;

	return (
		<Container>
			<Header
				className={activeItems.includes(id) ? 'active' : ''}
				onClick={() => handleToggle(id)}
			>
				<Title>{name}</Title>
				<ChevronIcon opened={activeItems.includes(id)}>
					<FiChevronDown />
				</ChevronIcon>
			</Header>
			<div
				ref={contentEl}
				className={`collapse ${activeItems.includes(id) ? 'show' : ''}`}
				style={{
					height: activeItems.includes(id)
						? contentEl?.current?.scrollHeight
						: 0,
				}}
			>
				{hasSlaValue && (
					<Paragraph margin="10px 0" fontStyle="italic">
						Tiempo estimado de recepción de resultados: de {minSla} a {maxSla}{' '}
						días.
					</Paragraph>
				)}
				<UnorderedList>
					{profileExams.map((exam: ProFileExamProps) => (
						<ListItem key={exam.id}>{exam.name}</ListItem>
					))}
				</UnorderedList>
			</div>
		</Container>
	);
};
